<template>
  <div id="app" v-if="data">
    <HeaderSite
      :menu="data.menu"
      :social="data.social"
      :logo="data.logo_white"
      :logo_color="data.logo_color"
    />
    <Featured
      v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"
      :featured="data.featured"
      id="featured"
    />
    <Video :video="data.video" />
    <WhereUse :cards="data.cards" />
    <BlockInfoProduct
      v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"
      class="container-termomagneticas"
      id="container-termomagneticas"
      :data="data.termomagneticas"
      position="left"
    />
    <BlockInfoProduct
      v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"
      class="container-diferenciales"
      id="container-diferenciales"
      :data="data.differentials"
      position="right"
    />
    <Guide
      v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"
      :data="data.guide"
      id="guide"
    />
    <Certified
      v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"
      :data="data.certificated"
      id="certified"
    />
    <Newsletter :data="data.newsletter" />
    <Institutional
      v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"
      :data="data.institutional"
      id="institutional"
    />
    <FooterSite
      :menu="data.menu"
      :social="data.social"
      :logo="data.logo_color"
      :rights="data.footer"
    />
  </div>
</template>

<script>
export default {
  components: {
    HeaderSite: () => import("./components/header-site/HeaderSite"),
    FooterSite: () => import("./components/footer-site/FooterSite"),
    Featured: () => import("./components/featured/Featured"),
    Video: () => import("./components/video/Video"),
    WhereUse: () => import("./components/where-use/WhereUse"),
    BlockInfoProduct: () =>
      import("./components/block-info-product/BlockInfoProduct"),
    Guide: () => import("./components/guide/Guide"),
    Certified: () => import("./components/certified/Certified"),
    Newsletter: () => import("./components/newsletter/Newsletter"),
    Institutional: () => import("./components/institutional/Institutional"),
  },
  created() {
    this.$store.dispatch("getContent");
  },
  computed: {
    data() {
      return this.$store.state.data;
    },
  },
  data: () => ({
    intersectionOptions: {
      threshold: [1],
    },
  }),
  methods: {
    onWaypoint({ going, direction, el }) {
      if (going && direction) {
        let item = document.getElementsByClassName(`nav-${el.id}`)[0];
        let itens = document.getElementsByClassName(`nav-item`);
        for (let index = 0; index < itens.length; index++) {
          const element = itens[index];
          element.classList.remove("nav-active");
        }
        item.classList.add("nav-active");
      }
    },
  },
};
</script>

<style lang="scss" src="./App.scss" />